/**
 * @generated SignedSource<<a5f6dc3a234f38c9715d043277dcf364>>
 * @relayHash a778a654f41d14dc8c26156ab6b006a5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a778a654f41d14dc8c26156ab6b006a5

import { ConcreteRequest } from 'relay-runtime';
export type AppointmentReviewStatus = "NEEDED" | "NONE" | "REVIEWED";
export type Flexibility = "FIXED_TIME" | "FLEXIBLE" | "NOT_EARLIER";
export type Urgency = "MEDICAL_ACUTE" | "MEDICAL_URGENT" | "NORMAL";
export type UpdateAppointmentUrgencyInput = {
  id: string;
  patientDateOfBirth?: any | null;
  urgency: Urgency;
};
export type useUpdateAppointmentUrgencyMutation$variables = {
  input: UpdateAppointmentUrgencyInput;
};
export type useUpdateAppointmentUrgencyMutation$data = {
  readonly updateAppointmentUrgency: {
    readonly appointment: {
      readonly flexibility: Flexibility;
      readonly reviewStatus: AppointmentReviewStatus;
      readonly urgency: Urgency;
    } | null;
  };
};
export type useUpdateAppointmentUrgencyMutation = {
  response: useUpdateAppointmentUrgencyMutation$data;
  variables: useUpdateAppointmentUrgencyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urgency",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flexibility",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reviewStatus",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateAppointmentUrgencyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateAppointmentUrgencyPayload",
        "kind": "LinkedField",
        "name": "updateAppointmentUrgency",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointment",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUpdateAppointmentUrgencyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateAppointmentUrgencyPayload",
        "kind": "LinkedField",
        "name": "updateAppointmentUrgency",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Appointment",
            "kind": "LinkedField",
            "name": "appointment",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "a778a654f41d14dc8c26156ab6b006a5",
    "metadata": {},
    "name": "useUpdateAppointmentUrgencyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "dda3600c45a3f11ac04185dc5399f0f5";

export default node;
